import type {
  JobBaseCategory,
  JobCategory,
} from 'src/app/constants/jobCategories';
import type {
  JobCategoryBaseTaxonomy,
  JobCategoryTaxonomy,
} from 'src/types/job-category';

const formatSubCategoryList = (
  data: JobBaseCategory[] = [],
): JobCategoryBaseTaxonomy[] =>
  Object.values<any>(data).reduce(
    (acc: JobCategoryBaseTaxonomy[], category) => {
      if (category.text && category.id) {
        acc.push({
          label: category.text,
          value: category.id.toString(),
          seekId: category.seekId.toString(),
        });
      }
      return acc;
    },
    [],
  );

export const formatJobCategoryTaxonomy = (
  data: JobCategory[],
): JobCategoryTaxonomy[] =>
  Object.values<JobCategory>(data).reduce((result, item) => {
    if (item.text && item.id) {
      result.push({
        label: item.text,
        value: item.id.toString(),
        seekId: item.seekId.toString(),
        subCategoryList: formatSubCategoryList(item.subClassifications),
      });
    }
    return result;
  }, [] as JobCategoryTaxonomy[]);
